import { render, staticRenderFns } from "./HealthCourses.vue?vue&type=template&id=922353f6"
import script from "./HealthCourses.vue?vue&type=script&lang=js"
export * from "./HealthCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports